import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colors } from '../../../../../ui/theme';
import { PerkCardContainer, PerkCardDescription, PerkCardTitle, PerkIconContainer } from './subcomponents';
var PerksCard = function (_a) {
    var title = _a.title, description = _a.description, icon = _a.icon;
    return (_jsxs(PerkCardContainer, { children: [_jsx(PerkIconContainer, { children: _jsx(FontAwesomeIcon, { "aria-hidden": "false", icon: icon, size: "2x", color: colors.white }) }), _jsx(PerkCardTitle, { children: title }), _jsx(PerkCardDescription, { children: description })] }));
};
export default PerksCard;
